import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CommonModule } from '@angular/common';
import { MasterUserPaginatedInterface } from 'app/modules/components/sales/order-generate/interfaces/master-user.interface';
import { UserMasterService } from 'app/modules/components/routing/sub-routes/sub-route-collaborator/user_master.service';
import { TemporaryPasswordService } from '../temporary-passwords/temporary-passwords.service';
import { ICreateTemporaryPassword } from '../temporary-passwords/dto/temporary-password.interface';
import { getCode } from 'app/utils/method';
import { TemporaryPasswordResultComponent } from './temporary-password-result.component';
import { take } from 'rxjs';

@Component({
  selector: 'app-temporary-password-create',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './temporary-password-create.component.html',
  styleUrls: ['./temporary-password-create.component.scss']
})
export class TemporaryPasswordCreateComponent implements OnInit {
  getCode = getCode;
  passwordForm!: FormGroup;
  originalAssignedUserList: MasterUserPaginatedInterface[] = [];
  filteredAssignedUserList: MasterUserPaginatedInterface[] = [];

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private userMasterService: UserMasterService,
    private temporaryPasswordService: TemporaryPasswordService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<TemporaryPasswordCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      targetUserId: ['', Validators.required],
      reason: ['', [Validators.required, this.noWhitespaceValidator]],
      durationInHours: [4, [Validators.required, Validators.min(1), Validators.max(8)]],
      searchAssignedUser: ['']
    });

    this.initListSeller();
  }

  private noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  /** Carga inicial de usuarios */
  private initListSeller(): void {
    const options = {
      currentPage: 1,
      limitPerPage: 50,
      search: null,
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(options).subscribe({
      next: (res) => {
        this.originalAssignedUserList = res.data;
        this.filteredAssignedUserList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      }
    });
  }

  /** Filtro de usuarios */
  filterAssignedUserByUserName(search: string): void {
    const value = search?.toLowerCase() ?? '';
    const dataToSend = {
      currentPage: 1,
      limitPerPage: 50,
      search: value,
      sort: "username"
    };

    this.userMasterService.getAllPaginateAllUsers(dataToSend).subscribe({
      next: (res) => {
        const news = res?.data ?? [];
        const mapaForId = new Map<string, MasterUserPaginatedInterface>();

        this.originalAssignedUserList.forEach(item =>
          mapaForId.set(item.user_login_id.toString(), item)
        );
        news.forEach(item =>
          mapaForId.set(item.user_login_id.toString(), item)
        );

        this.originalAssignedUserList = Array.from(mapaForId.values());
        this.filteredAssignedUserList = value
          ? this.originalAssignedUserList.filter(item =>
            item.user_login_first_name?.toLowerCase().includes(value)
          )
          : this.originalAssignedUserList;

        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al filtrar usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      }
    });
  }

  /** Guardar */
  onSubmit(): void {
    if (this.passwordForm.invalid) return;

    const formValue: ICreateTemporaryPassword = this.passwordForm.value;

    const dataToSend: ICreateTemporaryPassword = {
      targetUserId: formValue.targetUserId,
      reason: formValue.reason,
      durationInHours: formValue.durationInHours
    };

    this.temporaryPasswordService.create(dataToSend)
    .pipe(take(1))
    .subscribe({
      next: (res) => {
        this.snackBar.open('Contraseña temporal creada', 'Cerrar', { duration: 3000 });
        this.dialogRef.close(true);

        const username = res.data.targetUser.username || 'Usuario desconocido';

        this.dialog.open(TemporaryPasswordResultComponent, {
          width: '400px',
          data: {
            username,
            plainPassword: res.data.plainPassword,
            expiresAt: res.data.expiresAt
          }
        });
      },
      error: (err) => {
        this.snackBar.open(err.error?.message || 'Error al crear', 'Cerrar', { duration: 3000 });
      }
    });
  }


  onCancel(): void {
    this.dialogRef.close(false);
  }
}
